import type { FC, ReactNode } from 'react'

import { ArrowUpRight } from 'lucide-react'
import { buttonStyles } from '@/lib/button-styles'
import SectionLabel from '@/components/landing/section-label'
import WorkCard from '@/components/landing/work-card'
import { WORK_ITEMS } from '@/constants/landing'

const WorkSection: FC = (): ReactNode => {
    return (
        <section id='work' aria-labelledby='work-title' className='site-container pb-24 md:pb-36'>
            <div className='flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                <div>
                    <SectionLabel index='02'>
                        Selected work
                    </SectionLabel>

                    <h2
                        id='work-title'
                        className='reveal mt-6 font-heading text-[clamp(3.25rem,10vw,10rem)] leading-[0.82] font-black uppercase wdth-75'
                    >
                        Fresh off
                        <span className='block text-pop-orange'>
                            the shelf
                        </span>
                    </h2>
                </div>

                <p className='reveal max-w-sm text-lg leading-relaxed text-muted-foreground lg:text-right'>
                    Six recent launches, from soda to skincare. Every pack, render and wordmark made in-house.
                </p>
            </div>

            <ul className='mt-12 grid gap-4 md:mt-16 md:grid-cols-2 md:gap-5 lg:grid-cols-12'>
                {WORK_ITEMS.map(item => (
                    <WorkCard key={item.slug} item={item} />
                ))}
            </ul>

            <div className='reveal mt-5 flex flex-col items-start gap-6 rounded-[2rem] border-2 border-foreground p-6 md:flex-row md:items-center md:justify-between md:p-10'>
                <p className='font-heading text-[clamp(1.75rem,3.4vw,3rem)] leading-[0.95] font-black uppercase wdth-85'>
                    Your brand could be next on the shelf.
                </p>

                <a href='#contact' className={buttonStyles({ variant: 'ink', size: 'lg' })}>
                    Start a project
                    <ArrowUpRight aria-hidden='true' className='size-5 transition-transform duration-300 group-hover/button:rotate-45' />
                </a>
            </div>
        </section>
    )
}

export default WorkSection
